import { Link, useLocation } from 'react-router-dom';
import { Logo } from '../brand/Logo';

export type SidebarNavItem = {
  label: string;
  to?: string;
};

type AppSidebarProps = {
  orgLabel: string;
  items: SidebarNavItem[];
  backLabel: string;
  backTo: string;
};

export function AppSidebar({ orgLabel, items, backLabel, backTo }: AppSidebarProps) {
  const location = useLocation();

  return (
    <aside className="flex h-screen w-60 shrink-0 flex-col bg-bg-navigation px-4 py-6">
      <div className="px-2">
        <Logo variant="dark" size={20} />
        <p className="mt-1 truncate text-[10px] text-text-secondary">{orgLabel}</p>
      </div>

      <nav className="mt-8 flex flex-col gap-1">
        {items.map((item) => {
          const isActive = item.to != null && location.pathname === item.to;
          if (!item.to) {
            return (
              <span
                key={item.label}
                className="rounded-[10px] px-3.5 py-2.5 text-xs font-medium text-text-secondary/50"
              >
                {item.label}
              </span>
            );
          }
          return (
            <Link
              key={item.label}
              to={item.to}
              className={`rounded-[10px] px-3.5 py-2.5 text-xs font-medium transition-colors ${
                isActive
                  ? 'bg-action-primary font-semibold text-text-inverse'
                  : 'text-text-secondary hover:bg-bg-surface/10 hover:text-text-inverse'
              }`}
            >
              {item.label}
            </Link>
          );
        })}
      </nav>

      <Link
        to={backTo}
        className="mt-auto px-2 text-[11px] font-medium text-text-secondary hover:text-text-inverse"
      >
        ← {backLabel}
      </Link>
    </aside>
  );
}
